import {useEffect} from 'react';

/** A hook that listens to a DOM event on an element. */
export function useDomEvent(
  element: HTMLElement | Window | Document | null | undefined,
  type: string,
  listener: EventListener,
) {
  useEffect(() => {
    if (element) {
      element.addEventListener(type, listener);

      return () => {
        element.removeEventListener(type, listener);
      };
    }

    return undefined;
  }, [element, type, listener]);
}
